import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "correct-circle-outline-icon",
  "aria-label": "Correct icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M16.0216 10.136C16.3144 9.84315 16.3144 9.36828 16.0216 9.07538C15.7287 8.78249 15.2538 8.78249 14.9609 9.07538L10.6002 13.4361L8.97662 11.8125C8.68373 11.5196 8.20885 11.5196 7.91596 11.8125C7.62307 12.1054 7.62307 12.5803 7.91596 12.8732L10.0839 15.0411C10.3768 15.334 10.8516 15.334 11.1445 15.0411C11.1863 14.9993 11.2222 14.9537 11.2521 14.9055L16.0216 10.136Z" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12 2.25C6.61522 2.25 2.25 6.61522 2.25 12C2.25 17.3848 6.61522 21.75 12 21.75C17.3848 21.75 21.75 17.3848 21.75 12C21.75 6.61522 17.3848 2.25 12 2.25ZM3.75 12C3.75 7.44365 7.44365 3.75 12 3.75C16.5563 3.75 20.25 7.44365 20.25 12C20.25 16.5563 16.5563 20.25 12 20.25C7.44365 20.25 3.75 16.5563 3.75 12Z"
    }, null, -1)
  ])))
}
export default { render: render }